<template>	
	<el-form ref="ff" :rules="rules" :model="f">
		<el-form-item label="Статус заказа" label-position="top" prop="status">			
			<order-status-selector-component 
				:status="f.status"
				:statuses="newOrderAllowedStatuses"
				@change="onStatusChanged"
			/>
		</el-form-item>

		<el-form-item label="Плановая дата начала работ" label-position="top" prop="scheduledStartDate">
			<el-date-picker
				v-model="f.scheduledStartDate"
				@update:modelValue="emitUpdate"
				type="date"
				:clearable="false"
				format="DD.MM.YYYY"
				placeholder="Дата начала работ"
			/>
			&nbsp;
			<el-time-picker
				v-model="f.scheduledStartDate"
				@update:modelValue="emitUpdate"
				:clearable="false"
				format="HH:mm"
				placeholder="Время начала работ"
			/>
		</el-form-item>

		<el-form-item label="Организация-исполнитель" label-position="top" prop="executiveEntity">
			<el-select
				v-model="f.executiveEntity"
				filterable
				reserve-keyword
				placeholder="Выберите из списка"
				@update:modelValue="emitUpdate"
			>
				<el-option
					v-for="item in executives"
					:key="item.id"
					:label="item.name"
					:value="item" />
			</el-select>
		</el-form-item>

		<el-form-item label="Подразделение" label-position="top" prop="executiveEntityBranch">
			<el-select
				v-model="f.executiveEntityBranch"
				value-key="id"
				filterable
				reserve-keyword
				placeholder="Выберите из списка"
				:disabled="!f.executiveEntity?.id"
				@update:modelValue="emitUpdate"
			>
				<el-option
					v-for="item in f.executiveEntity?.branches"
					:key="item.id"
					:label="item.name"
					:value="item" />
			</el-select>
		</el-form-item>

		<el-form-item label="Менеджер" label-position="top" prop="manager">
			<select-manager-component
				v-model="f.managerId"
				:load-managers="true"
				@update:modelValue="emitUpdate"
			/>
		</el-form-item>

		<el-form-item label="Заказчик (контрагент)" label-position="top" prop="customer">		
			<div v-if="!f.vehicle?.id" style="width: 100%;">
				<catalog-picker-component
					ref="c"
					auth
					v-model="f.customer"
					placeholder="Поиск по имени, фамилии, отчеству, компании, телефону или email" 
					:catalog-tab="counterpartiesCatalogTab"
					search-url="/api/counterparties/search"
					@update:modelValue="emitUpdate"
					@catalog-item-picked="onCustomerPickedFromCatalog">
					<template #default="scope">		
						<span style="float: left">{{ `${scope.lastname} ${scope.firstname} ${scope.middlename ?? ''}` }}</span>
						<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">{{ scope.phone }}</span>
					</template>
					<template #label>
						<span style="float: left">{{ `${f.customer!.lastname} ${f.customer!.firstname} ${f.customer!.middlename ?? ''}` }}</span>
						<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">{{ f.customer!.phone }}</span>
					</template>
				</catalog-picker-component>
			</div>
			<div v-else style="width: 100%">
				<el-select
					clearable
					v-model="f.customerId"
					@update:modelValue="emitUpdate"
					@clear="onCounterpartySelectClear">
					<template #label>
						<div>
							<span style="float: left">{{ `${f.customer?.lastname} ${f.customer?.firstname} ${f.customer?.middlename ?? ''}` }}</span>
							<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">{{f.customer?.phone}}</span>
						</div>
					</template>
					<el-option v-for="c in customers"
						:key="c.id"
						:value="c.id"
						:label="`${c.lastname} ${c.firstname} ${c.middlename ?? ''}`"/>
				</el-select>
			</div>					
		</el-form-item>

		<el-form-item label="Автомобиль" label-position="top" prop="vehicle">
			<div v-if="!f.customer?.id" style="width: 100%;">
				<catalog-picker-component
					ref="v"
					auth
					v-model="f.vehicle"
					placeholder="Поиск по марке, производителю, VIN или гос. номеру автомобиля" 
					search-url="/api/vehicles/search"
					:catalog-tab="vehicleCatalogTab"
					:allow-creating="true"
					@update:modelValue="emitUpdate"
					@catalog-item-picked="onVehiclePickedFromCatalog">
					<template #default="scope">
						<div>
							<span style="float: left">{{ `${scope.model?.manufacturer?.name}, ${scope.model?.name}` }}</span>
							<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">
								{{ scope.govermentalNumber ? scope.govermentalNumber : scope.vin }}
							</span>
						</div>
					</template>
				</catalog-picker-component>
			</div>
			<div v-else style="width: 100%;"> 
				<el-select
					v-model="f.vehicleId"
					placeholder="Список автомобилей контрагента"
					@change="onVehicleSelectChange"
					@update:modelValue="emitUpdate">
					<el-option v-for="item in customerVehicles"
						:key="item.id"
						:value="item.id"
						:label="`${item.model?.manufacturer?.name}, ${item.model?.name} ${item.govermentalNumber ? item.govermentalNumber : item.vin}`">
					</el-option>
				</el-select>
			</div>
		</el-form-item>

		<el-form-item label="Комментарии заказчика" label-position="top">
			<el-input
				v-model="f.customerNotes"
				@update:modelValue="emitUpdate"
				:autosize="{ minRows: 3, maxRows: 6 }"
				type="textarea"
				maxlength="5000"
				show-word-limit
				placeholder="Комментарии заказчика, видны всем"
			/>
		</el-form-item>

		<el-form-item label="Внутренние комментарии" label-position="top">
			<el-input
				v-model="f.internalNotes"
				@update:modelValue="emitUpdate"
				:autosize="{ minRows: 3, maxRows: 6 }"
				type="textarea"
				maxlength="5000"
				show-word-limit
				placeholder="Внутренние комментарии, видны только сотрудникам"
			/>
		</el-form-item>
	</el-form>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Delete, Edit, Plus, Search } from '@element-plus/icons-vue';
import IOrderComponent from './IOrderComponent';
import { WatchStopHandle, reactive, watch } from 'vue';
import IOrderCommonForm from './IOrderCommonForm';
import VehicleApiHelper from '@/helpers/api/VehicleApiHelper';
import Vehicle from '@/models/Vehicle';
import LegalEntityModel from '@/models/LegalEntityModel';
import orderStatusesHelper from '@/helpers/orderStatusHelper';
import TabsDictionary from '@/variables/tabs';
import store from '@/store';
import VehicleModel from '@/models/VehicleModel';
import CounterpartyModel from '@/models/CounterpartyModel';
import SelectManagerComponent from '../SelectManagerComponent.vue';
import CatalogPickerComponent from '../CatalogPickerComponent.vue';
import OrderStatusComponent from '../OrderStatusComponent.vue';
import { FormInstance, FormRules } from 'element-plus';
import OrderModel from '@/models/OrderModel';
import OrderStatusSelectorComponent from '../OrderStatusSelectorComponent.vue';
import OrderStatus from '@/models/enums/OrderStatus';
import OrderStatusModel from '@/models/OrderStatusModel';

@Options({
	components: {		
		CatalogPickerComponent,
		OrderStatusComponent,
		SelectManagerComponent,
		OrderStatusSelectorComponent
	},
	props: {
		order: {
			type: Object,
			default: null
		},
		executives: {
			type: Array,
			default: null
		},
		modelValue: {
			type: Object,
			default: null
		},
		creatingMode: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue']
})
export default class OrderCommonFormComponent extends Vue implements IOrderComponent {
	/** props */	
	order!: OrderModel | null;
	executives!: Array<LegalEntityModel>;
	modelValue!: IOrderCommonForm;
	creatingMode!: boolean;

	/** constants */
	searchIcon = Search;
	deleteIcon = Delete;
	editIcon = Edit;
	plusIcon = Plus;
	vehicleApiHelper = new VehicleApiHelper();
	isDecodeVinEnabled = false;	
	defaultOrderStatus = OrderStatus.VisitNegotiating;
	
	vehicleCatalogTab = TabsDictionary.vehicles;
	employeesCatalogTab = TabsDictionary.users;
	counterpartiesCatalogTab = TabsDictionary.counterparties;

	/** view-models */
	newOrderAllowedStatuses: Array<number> | null = null;

	f: IOrderCommonForm = {
		id: 0,		
		scheduledStartDate: new Date(),
		/** order initial status (id) */
		status: this.defaultOrderStatus,
		/** order's responsible entity */
		executiveEntity: null,
		/** order's responsible entity branch */
		executiveEntityBranch: null,
		/** customer */
		customer: null,
		customerId: null,
		/** customer's vehicle */
		vehicle: null,	
		vehicleId: null,
		/** order's manager */
		managerId: null,

		customerNotes: null,
		internalNotes: null,
		notesForCustomer: null
	};

	/** form rules set */
	rules = reactive<FormRules<any>>({
		scheduledStartDate: [
			{ required: true, validator: (a: any, b: any, c: any) => this.scheduledStartDateValidator(a,b,c), trigger: 'blur' }
		],
		executiveEntity: [
			{ required: true, message: 'Выберите контрагента, ответственного за заказ-наряд', trigger: 'click' }
		],
		executiveEntityBranch: [
			{ required: true, message: 'Выберите подразделение, ответственного за заказ-наряд', trigger: 'click' }
		],
		customer: [
			{ required: true, message: 'Укажите заказчика заказ-наряда', trigger: 'blur' }
		],
		vehicle: [
			{ required: true, validator: (a: any, b: any, c: any) => this.vehicleValidator(a,b,c), trigger: 'blur' }
		],
		manager: [
			{ required: true, validator: (a: any, b: number, c: Function) => this.managerValidator(a,b,c), trigger: 'blur' }
		]
	});

	customerVehicles = new Array<Vehicle>();
	customers: Array<any> | null = null;

	customerWatchStopHandler?: WatchStopHandle;
	customerVehicleWatchStopHandler?: WatchStopHandle;

	mounted() {
		watch(
			() => this.modelValue.status,
			(v) => {
				if (!v) {
					this.f.status = this.defaultOrderStatus;
				} else {
					this.f.status = v;
				}

				if (this.creatingMode) {
					this.newOrderAllowedStatuses = orderStatusesHelper.newOrderStatuses();
				} else {
					const statuses = store.getters.orderStatuses as Array<OrderStatusModel>;
					this.newOrderAllowedStatuses = statuses
						.find(s => s.id == v)?.subStatuses?.map(_ => _.id) ?? [];
				}
			}
		);

		watch(
			() => this.creatingMode,
			(v) => {
				if (v) {
					this.newOrderAllowedStatuses = orderStatusesHelper.newOrderStatuses();
				} else {
					this.newOrderAllowedStatuses = null;
				}
			}
		);

		watch(
			() => this.modelValue.id,
			v => this.f.id = v
		);

		watch(
			() => this.modelValue.scheduledStartDate,
			v => this.f.scheduledStartDate = v
		);

		watch(
			() => this.modelValue.executiveEntity,
			v => this.f.executiveEntity = v
		);

		watch(
			() => this.modelValue.executiveEntityBranch,
			v => this.f.executiveEntityBranch = v
		);

		watch(
			() => this.modelValue.managerId,
			v => this.f.managerId = v
		);

		watch(
			() => this.modelValue.customerNotes,
			v => this.f.customerNotes = v
		);

		watch(
			() => this.modelValue.internalNotes,
			v => this.f.internalNotes = v
		);

		this.customerWatchStopHandler = watch(
			() => this.modelValue.customer,
			v => {
				if (!v) {
					if (this.f.customer) {
						this.onCustomerPickedFromCatalog(null);
					}
					return;
				}

				this.customers = [v];
				this.f.customer = v;
				this.f.customerId = v.id;
				// Sync order's vehicle immediately so the select shows correct value before vehicles list loads
				const orderVehicle = this.modelValue.vehicle;
				const orderVehicleId = orderVehicle?.id ?? this.modelValue.vehicleId ?? null;
				if (orderVehicleId != null) {
					this.f.vehicleId = orderVehicleId as number;
					this.f.vehicle = orderVehicle ?? null;
				}

				this.vehicleApiHelper
					.getCounterpartyVehiclesAsync(store.getters.jwt, v.id)
					.then(vehicles => {
						if (!vehicles?.length) {
							this.customerVehicles = [];
							return;
						}
						this.customerVehicles = vehicles;
						// Preserve order's vehicle when editing: use modelValue if it's in the loaded list
						const currentOrderVehicleId = this.modelValue.vehicle?.id ?? this.modelValue.vehicleId ?? null;
						const matchingVehicle = currentOrderVehicleId != null
							? vehicles.find(veh => veh.id == currentOrderVehicleId)
							: null;
						if (matchingVehicle) {
							this.f.vehicle = matchingVehicle;
							this.f.vehicleId = matchingVehicle.id;
						} else if (this.f.vehicleId == null) {
							this.f.vehicle = vehicles[0];
							this.f.vehicleId = vehicles[0].id;
						}
						// else keep existing f.vehicleId / f.vehicle (already set from modelValue above)
					});
			}
		);

		this.customerVehicleWatchStopHandler = watch(
			() => this.modelValue.vehicle,
			(v) => {				
				// if (!v?.id &&
				// 	v?.vin?.length >= 15 &&
				// 	v?.vin?.length <= 20 &&
				// 	!this.isDecodeVinEnabled) {
				// 	this.isDecodeVinEnabled = true;
				// } else {
				// 	if (this.isDecodeVinEnabled) {
				// 		this.isDecodeVinEnabled = false;
				// 	}
				// }

				if (this.f.customer?.id) {
					return;
				}

				if (v?.counterparty?.id) {
					const customer = v.counterparty;
					this.onCustomerPickedFromCatalog(customer);			
					this.f.customer = customer;
					this.f.customerId = customer.id;
					this.customers = [customer];
				} else {	
					this.onCustomerPickedFromCatalog(null);
					this.customers = null;			
					this.f.customer = null;
					this.f.customerId = null;
				}
			}
		);
	}

	unmounted() {
		if (this.customerWatchStopHandler) {
			this.customerWatchStopHandler()
		}

		if (this.customerVehicleWatchStopHandler) {
			this.customerVehicleWatchStopHandler();
		}
	}

	emitUpdate() {
		this.$emit('update:modelValue', this.f);
	}

	scheduledStartDateValidator(field: any, value: Date, callback: Function) {
		//TODO:
		//Disabled for period of migrating past orders from 1c to iq-car
		return true;
		
		/* eslint-disable */ 
		//TODO:
		//Disable changing of order's scheduled start date for certain order-statuses
		if (!this.creatingMode) {
			return true;
		}

		const now = new Date();
		const timeDiffMinutes = 10;
		now.setTime(now.getTime() - (timeDiffMinutes * 60 * 1000));		
		if (value < now) {
			callback(new Error('Дата планового старта работ не может быть меньше текущй'));
			return false;
		}

		return true;
	}
	
	vehicleValidator(field: any, value: any, callback: Function) {		
		if (!this.f.vehicle?.id) {
			if (!this.f.customer?.id) {
				callback(new Error('Автомобиль не выбран'));
			} else {
				callback(new Error('Выберите автомобиль заказчика'));
			}
			return false;
		}

		return true;
	}

	managerValidator(field: any, managerId: number, callback: Function) {
		if (!this.f.managerId) {
			callback(new Error('Менеджер заказ-наряда должен быть выбран'));
			return false;
		}

		return true;
	}

	async validateAsync() : Promise<boolean> {
		try {
			const isValid = await (this.$refs.ff as FormInstance).validate();
			return isValid;
		} catch (e) {			
			return false;
		}
	}

	onCounterpartySelectClear() {
		this.f.customer = null;
		this.f.customerId = null;
		this.f.vehicle = null;
		this.f.vehicleId = null;

		this.emitUpdate();
	}

	onVehicleSelectChange(vehicleId: number) {
		this.f.vehicle = this.customerVehicles.find(_ => _.id == vehicleId)!;
		this.emitUpdate();
	}

	onVehiclePickedFromCatalog(vehicle: VehicleModel | null) {		
		const vehicleComponent = this.$refs.v as any;
		vehicleComponent?.set(vehicle);
		this.emitUpdate();
	}

	onCustomerPickedFromCatalog(counterparty: CounterpartyModel | null) {
		const onCounterpartyComponent = this.$refs.c as any;
		onCounterpartyComponent?.set(counterparty);

		if (counterparty?.id) {
			this.f.customerId = counterparty.id;
			this.customers = [counterparty];
		} else {
			this.f.customerId = null;
			this.customers = [];
		}

		this.emitUpdate();
	}

	onStatusChanged(status: number) {
		this.f.status = status;
		this.emitUpdate();
	}
}
</script>